import { useState } from "react";
import { useBreakpoint } from "hooks/use-breakpoint";
import { isMobile } from "react-device-detect";
import lottieUrl from "./lottie.json?url";
import {
  PhoneMobileView,
  PhoneView,
  Container,
  Lottie,
  PhoneLottie,
  LottieContainer,
  PhoneContainer,
  StaticPhoneContainer,
  StaticPhone,
} from "./styles";

export function Art({ showLottie }: { showLottie: boolean }) {
  const isTablet = useBreakpoint("md");
  const [lottieLoaded, setLottieLoaded] = useState(false);

  return (
    <Container>
      {isMobile && !isTablet ? (
        <PhoneMobileView />
      ) : showLottie ? (
        <LottieContainer>
          <PhoneContainer>
            <PhoneLottie />
          </PhoneContainer>
          {!lottieLoaded && (
            <StaticPhoneContainer>
              <StaticPhone />
            </StaticPhoneContainer>
          )}
          <Lottie
            url={lottieUrl}
            play
            onLoad={() => {
              setLottieLoaded(true);
            }}
          />
        </LottieContainer>
      ) : (
        <PhoneView />
      )}
    </Container>
  );
}
